import { LeftRight } from "@/components/LeftRight.tsx";
import { type ConfiguredWSelectProps, WSelect } from "@/components/forms/WSelect.tsx";
import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import type { HostPoolWithType } from "@/modules/pools/hostPoolsQuery.ts";

export interface PoolSelectProps extends ConfiguredWSelectProps<HostPoolWithType, string> {
    location: string;
}

function PoolIcon() {
    return <MaskIcon className="size-1.125rem jp-cluster-icon text-primary" />;
}

export function PoolSelectCustom({ items, ...props }: PoolSelectProps) {
    const { onChange } = props;

    return (
        <WSelect
            aria-label="Hypervisor pool"
            items={items}
            getKey={(item) => item.uuid}
            getTextValue={(item) => item.name}
            searchItems
            onChange={onChange}
            {...props}
        >
            {(item) => <LeftRight icon={<PoolIcon />} title={item.name} />}
        </WSelect>
    );
}
